import {weakMemo} from '@packages/utilities/memo';
import {Component} from '@packages/systems/wfdl';
import {
  getNamedElements,
  type NamedElementEntry,
} from '@packages/utilities/platform';

// Gets a list of elements on this page that have an id attribute, sorted alphabetically by attrId
export const getSortedNamedElements = weakMemo(
  (components: Component.ComponentMap): NamedElementEntry[] => {
    return getNamedElements(components).sort((a, b) => {
      return a.attrId.localeCompare(b.attrId);
    });
  }
);
